module.exports = "/components/components/exportButtonComponent-d196d4.html";